import { z } from "zod";
export const EventDataSourceImported = z.object({
    type: z.literal("DataSourceImported"),
    workspaceId: z.string(),
    designSystemId: z.string(),
    // The following fields are marked as optional for backward compatibility, but will be always
    // provided. Optional part can be removed once this change is fully deployed to production, until
    // then it has to be optional
    importJobId: z.string().optional(),
});
